import React from 'react';
import { Nav, Footer, DisclaimerBar } from '../components/Chrome';
import { useI18n } from '../i18n';

const CONTENT = {
  en: {
    title: 'Terms of Service',
    updated: 'Effective: January 2026',
    sections: [
      ['1. Nature of Service',
        'Pythia is a Real Estate Decision Intelligence service operated by PHEI Group. Pythia delivers model-assisted due diligence reports. Pythia reports are NOT appraisals, NOT lender-grade AVMs, and NOT investment advice. Pythia does not warrant fitness of a property for purchase, sale, financing, or investment.'],
      ['2. No Fiduciary Relationship',
        'Use of Pythia does not create a fiduciary, broker, agent, appraiser, or advisor relationship. You remain solely responsible for all decisions, offers, contracts, financing, and investments related to any property analyzed.'],
      ['3. Data Sources & Missingness',
        'Pythia reports declare data sources, confidence levels, and missingness. Data is compiled from user-supplied inputs, public record placeholders, and model-hypothesis inference. Pythia does not guarantee completeness or accuracy and will not be liable for reliance on values marked with partial or full missingness.'],
      ['4. Payments & Refunds',
        'Payments are processed by Stripe. Reports are delivered digitally within the SLA of the purchased product (48h standard, 24h rush). Refunds are considered case-by-case where the report was not delivered or where a material methodological defect is documented. Refund requests must be submitted within 14 days.'],
      ['5. Intellectual Property',
        'Reports are licensed for use by the purchaser and their internal advisors only. Redistribution, resale, or use as the sole basis for a lending or credit decision by third parties is prohibited.'],
      ['6. Limitation of Liability',
        'To the maximum extent permitted by law, PHEI Group and Pythia will not be liable for any indirect, incidental, consequential, or special damages. Aggregate liability is limited to the price paid for the specific report at issue.'],
      ['7. Compliance Positioning',
        'Pythia is designed to operate outside the regulated definition of "appraisal" (USPAP) and outside the FHFA/Interagency AVM quality-control regime applicable to covered credit decisions. Purchasers requiring appraisal, USPAP compliance, or lender-grade AVM must engage a licensed/certified appraiser.'],
      ['8. Governing Law',
        'These terms are governed by the laws of the State of Florida, USA. Any dispute will be resolved in the state or federal courts of Broward County, Florida.'],
      ['9. Contact',
        'For questions about these Terms, write to ceo@pheigroup.com.'],
    ],
  },
  es: {
    title: 'Términos de Servicio',
    updated: 'Vigentes: enero 2026',
    sections: [
      ['1. Naturaleza del Servicio',
        'Pythia es un servicio de Inteligencia de Decisión Inmobiliaria operado por PHEI Group. Pythia entrega reportes de due diligence asistidos por modelo. Los reportes NO son tasaciones, NO son AVMs lender-grade y NO constituyen asesoría de inversión. Pythia no garantiza la idoneidad de una propiedad para compra, venta, financiamiento o inversión.'],
      ['2. Sin Relación Fiduciaria',
        'El uso de Pythia no crea una relación fiduciaria, de broker, agente, tasador o asesor. Tú eres el único responsable de todas las decisiones, ofertas, contratos, financiamientos e inversiones relacionadas con cualquier propiedad analizada.'],
      ['3. Fuentes y Missingness',
        'Los reportes de Pythia declaran fuentes, niveles de confianza y missingness. Los datos provienen de inputs del usuario, placeholders de registro público y model-hypothesis. Pythia no garantiza completitud ni exactitud y no será responsable por la confianza depositada en valores marcados con missingness parcial o total.'],
      ['4. Pagos y Reembolsos',
        'Los pagos se procesan por Stripe. Los reportes se entregan digitalmente dentro del SLA del producto (48h estándar, 24h rush). Los reembolsos se evalúan caso por caso donde el reporte no fue entregado o donde se documente un defecto metodológico material. Las solicitudes de reembolso deben enviarse dentro de 14 días.'],
      ['5. Propiedad Intelectual',
        'Los reportes se licencian para uso del comprador y sus asesores internos únicamente. Se prohíbe la redistribución, reventa o uso como única base para decisiones de crédito por terceros.'],
      ['6. Limitación de Responsabilidad',
        'Hasta el máximo permitido por ley, PHEI Group y Pythia no serán responsables por daños indirectos, incidentales, consecuenciales o especiales. La responsabilidad total se limita al precio pagado por el reporte específico en cuestión.'],
      ['7. Posicionamiento Regulatorio',
        'Pythia está diseñado para operar fuera de la definición regulada de "appraisal" (USPAP) y fuera del régimen de calidad AVM de FHFA/Interagency aplicable a decisiones de crédito cubiertas. Compradores que requieran tasación, USPAP o AVM lender-grade deben contratar un tasador licenciado/certificado.'],
      ['8. Ley Aplicable',
        'Estos términos se rigen por las leyes del Estado de Florida, EE. UU. Cualquier disputa se resolverá en tribunales estatales o federales del Condado de Broward, Florida.'],
      ['9. Contacto',
        'Para preguntas sobre estos términos, escribe a ceo@pheigroup.com.'],
    ],
  },
};

export default function Terms() {
  const { lang } = useI18n();
  const c = CONTENT[lang] || CONTENT.en;
  return (
    <div>
      <Nav />
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-16">
        <div className="mono text-[10px] uppercase tracking-widest2 text-gold mb-4">LEGAL</div>
        <h1 className="serif text-5xl">{c.title}</h1>
        <div className="mono text-[10px] uppercase tracking-widest2 text-white/40 mt-2">{c.updated}</div>
        <div className="mt-10 space-y-8">
          {c.sections.map(([h, b], i) => (
            <div key={i}>
              <h2 className="serif text-xl text-gold">{h}</h2>
              <p className="mt-2 text-white/75 leading-relaxed">{b}</p>
            </div>
          ))}
        </div>
      </div>
      <DisclaimerBar />
      <Footer />
    </div>
  );
}
